import React, { Fragment } from 'react';

import styles from './rotatingLine.module.scss';

const RotatingLine = () => {
  return (
    <Fragment>
      <div className={`${styles.animated} ${styles.first}`} />
      <div className={`${styles.animated} ${styles.second}`} />
    </Fragment>
  );
};

export default RotatingLine;
